function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { crudUserProfile } from '@/mixins/crud_user_profile.js';
import UserProfileService from '@/apps/data-platform/services/user_profile_service';
import PaginationBasic from '@/components/PaginationBasic.vue';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
export default {
  name: 'ProfilePage',
  mixins: [crudUserProfile],
  components: {
    PaginationBasic: PaginationBasic,
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  data: function data() {
    return {
      alert: false,
      dialogFlag: false,
      select_profile_users: [],
      users_to_filters: [],
      select_areas: [],
      modalId: 'dp_userprofile',
      collapse_filter: false,
      menu: false,
      menu2: false,
      dates: [],
      area_filter: [],
      filters: {
        fechas: []
      },
      filter_enabled: false,
      // true,
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      }
    };
  },
  computed: {
    /* ...mapState('data-platform', ['select_profile_users', 'select_profile_areas']),*/headers: function headers() {
      return [{
        value: 'userprofile_description',
        text: this.traductor('tablas.name'),
        sortable: true,
        class: 'text-left'
      }, {
        value: 'area_description',
        text: this.traductor('tablas.area'),
        sortable: true,
        class: 'text-center'
      }, {
        value: 'load_date',
        text: this.traductor('frases.update_date'),
        sortable: true,
        class: 'text-left',
        align: 'center'
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions'),
        class: 'text-center',
        align: 'center'
      }];
    },
    texts: function texts() {
      return {
        name: this.traductor('tablas.name'),
        area: this.traductor('tablas.area'),
        active: this.traductor('frases.activo'),
        updated_by: this.traductor('frases.updated_by'),
        update_date: this.traductor('frases.update_date'),
        rango: this.traductor('filtros.rango')
      };
    },
    modalName: function modalName() {
      return this.traductor('menu.dp.up_user_profile');
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    dateRangeText: function dateRangeText() {
      return this.filters.fechas ? this.filters.fechas.join(' ~ ') : '';
    }
  },
  created: function created() {
    this.getAreas();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    getRecords: function getRecords() {
      var _this = this;
      this.parametros = {
        domain: 'intercorp.com.pe'
      };
      this.toggleBusy();
      UserProfileService.getUserProfiles(this.parametros).then(function (data) {
        _this.toggleBusy();
        console.log(data);
        _this.select_profile_users = data.data;
        _this.users_to_filters = data.data;
      }, function (err) {
        _this.toggleBusy();
        console.og(err);
      });
    },
    getAreas: function getAreas() {
      var _this2 = this;
      this.parametros = {
        domain: 'intercorp.com.pe'
      };
      UserProfileService.getAreas(this.parametros).then(function (data) {
        console.log('debug:', data.data);
        // this.select_areas = data.data
        data.data.forEach(function (element) {
          _this2.area_filter.push({
            text: element.area_description
          });
          _this2.select_areas.push({
            value: element.area_id,
            text: element.area_description
          });
        });
      }, function (err) {
        console.og(err);
      });
    },
    onSearch: function onSearch() {
      var _this3 = this;
      console.log('1: ', this.filters);
      this.select_profile_users = Object.assign([], this.users_to_filters);
      if (this.filters.nombre) {
        this.select_profile_users = this.select_profile_users.filter(function (x) {
          return x.userprofile_description.toUpperCase().indexOf(_this3.filters.nombre.toUpperCase()) != -1;
        });
      }
      if (this.filters.area) {
        this.select_profile_users = this.select_profile_users.filter(function (x) {
          return x.area_description.toUpperCase().indexOf(_this3.filters.area.toUpperCase()) != -1;
        });
      }
      if (this.filters.fechas) {
        if (_typeof(this.filters.fechas) === 'object') {
          if (this.filters.fechas.length > 1) {
            this.select_profile_users = this.select_profile_users.filter(function (x) {
              return x.load_date.substring(0, 10) >= _this3.filters.fechas[0] && x.load_date.substring(0, 10) <= _this3.filters.fechas[1];
            });
          }
        }
      }
    },
    onLimpiar: function onLimpiar() {
      this.select_profile_users = Object.assign([], this.users_to_filters);
      this.resetFilters();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
    }
  }
};